/**
 * Gluky Users API - Test
 * Gluky\'s apps and programs definitions and of the users authorized to access them, including their roles and other authorization information.
 *
 * The version of the OpenAPI document: 1.2.0
 * Contact: sistemas@gluky.cop
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OpenIDInfo } from "./openIDInfo";
import { UnconstrainedApp } from "./unconstrainedApp";
import { AppAllOf } from "./appAllOf";

export interface LoginRegisterConfig {
  log_in: {
    method: 'password' | 'email_link' | 'phone_otp' | 'email_link_or_phone_otp' | 'google' | 'saml' | 'openid';
    google?: boolean;
    saml?: {
      provider: string;
      label: string;
      description?: string;
    };
    openid?: {
      provider: string;
      label: string;
      description?: string;
    };
  };
  register?: {
    method: 'disabled' | 'code' | 'email_link' | 'phone_otp' | 'open';
    google?: boolean;
    /** Método de recuperación preferido. Si no se envía, se permiten ambos. Solo aplica cuando method === 'code' */
    preferred_recovery_method?: 'email' | 'phone';
  };
  account_search_field?: 'username' | 'iddoc' | 'email' | 'phone';
  account_label?: string;
  register_code_label?: string;
  iddoc_label?: string;
  iddoc_type_label?: string;
  iddoc_type_options?: string[];
  session_expiration?: {
    enable: boolean;
    inactivity_timeout_seconds?: number;
  };
}

export interface App {
  name: string;
  id: string;
  pwa_domain?: string;
  /** @deprecated Use login_register.account_label */
  account_label?: string;
  /** @deprecated Use login_register.register_code_label */
  register_code_label?: string;
  /** @deprecated Use login_register.iddoc_label */
  iddoc_label?: string;
  /** @deprecated Use login_register.iddoc_type_label */
  iddoc_type_label?: string;
  /** @deprecated Use login_register.iddoc_type_options */
  iddoc_type_options?: string[];
  login_register?: LoginRegisterConfig;
  gcp: {
    main_project_id: string;
    recaptcha_auth: boolean;
    recaptcha_secret: string;
    recaptcha_enterprise: boolean;
    recaptcha_min_score: number;
    recaptcha_keys_ids: string[];
    custom_token_signer?: boolean;
  };
  auth_jwt_info: {
    issuer: string;
    audiences: string[];
    jwks_uri: string;
  };
  register_type?: string;
  puntored_recaudo:{
    factor:number;
    offset_cents : number;
  }
  card_terminal:{
    factor:number;
    offset_cents : number;
  }
  short_lived_tokens?: boolean;
  expire_elastic_token?: boolean;
  twilio?: TwilioData;
  enumeration_protection?: boolean;
  verify_recovery_info?: boolean;
  enabled?: boolean;
}

export interface TwilioData {
  enabled?: boolean;
  verify_sid: string;
  token: string;
  sid: string;
}
